module.exports = __webpack_public_path__ + "img/win_item9.2a1ef0f5.png";